import { createGlobalStyle, css } from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

const { focusRing, focusRingOnNavy } = adminTokens;

// The keyboard focus outline every admin control shows, 2px outside it (XCUT-R38).
// Use it inside a `:focus-visible` rule so a mouse click draws nothing.
export const focusOutline = css`
  outline: ${focusRing.width}px solid ${focusRing.color};
  outline-offset: ${focusRing.offset}px;
`;

// A text field, search input or select shows the outline at its edge (FIELD-R5, SEARCH-R9).
export const focusOutlineAtEdge = css`
  outline: ${focusRing.width}px solid ${focusRing.color};
  outline-offset: 0;
`;

// A control on the navy notice strip shows the outline in white (XCUT-R39).
export const focusOutlineOnNavy = css`
  outline: ${focusRingOnNavy.width}px solid ${focusRingOnNavy.color};
  outline-offset: ${focusRingOnNavy.offset}px;
`;

// The shared component library's reset rings every focused button, even after a mouse
// click; while the admin is shown, only focus from the keyboard draws an outline (XCUT-R38).
export const AdminFocusStyle = createGlobalStyle`
  body :focus:not(:focus-visible) {
    outline: none;
  }
`;
